import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const HybridEzParentDelivery = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        pdfFile={pdfFiles.hybridDelivery[4]}
        vidSrc={1195764249}
      />
    </div>
  );
};

export default HybridEzParentDelivery;
